// App.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "./components/Dashboard/Employee";
import Messages from "./components/Dashboard/Employee/Messages";
import MyJobs from "./components/Dashboard/Employee/MyJobs";
import NavBar from "./components/Dashboard/Employee/Navbar";
import Profile from "./components/Dashboard/Employee/Profile";
import EmployerCandidates from "./components/Dashboard/Employer/Candidates";
import EmployerDashboard from "./components/Dashboard/Employer/Dash";
import EmployerJobs from "./components/Dashboard/Employer/Jobs";
import EmployerMessages from "./components/Dashboard/Employer/Messages";
import PostYourJob from "./components/Dashboard/Employer/PostJob";
import ResumeDatabase from "./components/Dashboard/Employer/ResumeDatabase";
import EmployerSidebar from "./components/Dashboard/Employer/Sidebar";
import Home from "./components/MainHome";
import EmployerOnboarding from "./components/Onboarding/EmployerOnboarding";
import Onboarding from "./components/Onboarding/index.jsx";
import SearchResults from "./components/SearchResults";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/search" element={<SearchResults />} />
      <Route path="/employer-onboarding" element={<EmployerOnboarding />} />
      <Route path="/employer" element={<EmployerSidebar />}>
        <Route path="post-job" element={<PostYourJob />} />
        <Route path="dashboard" element={<EmployerDashboard />} />
        <Route path="jobs" element={<EmployerJobs />} />
        <Route path="resume-db" element={<ResumeDatabase />} />
        <Route path="candidates" element={<EmployerCandidates />} />
        <Route path="messages" element={<EmployerMessages />} />
      </Route>
      <Route path="/jobseeker" element={<NavBar />}>
        <Route path="home" element={<Dashboard />} />
        <Route path="my-jobs" element={<MyJobs />} />
        <Route path="messages" element={<Messages />} />
        <Route path="profile" element={<Profile />} />
      </Route>
    </Routes>
  );
};

export default App;
